import { render, staticRenderFns } from "./ReportStockMovementsPage.vue?vue&type=template&id=19bf60dd&scoped=true"
import script from "./ReportStockMovementsPage.vue?vue&type=script&lang=js"
export * from "./ReportStockMovementsPage.vue?vue&type=script&lang=js"
import style0 from "./ReportStockMovementsPage.vue?vue&type=style&index=0&id=19bf60dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bf60dd",
  null
  
)

export default component.exports